var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 366.396,
    height: 317.75,
    viewBox: "0 0 366.396 317.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.865)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.865 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M359.247,142.2,288.8,248.353l18.24,18.24,106.153-70.447Z",
    transform: "translate(-85.171 -53.771)",
    fill: "#e5bc09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.147,142.2l70.447,106.153-18.24,18.24L30.2,196.147Z",
    transform: "translate(6.754 -53.771)",
    fill: "#6bdae5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.625,
    cy: 38.625,
    rx: 38.625,
    ry: 38.625,
    transform: "translate(20.759 72.239)",
    fill: "#53ffe9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H90.234V12.891H0Z",
    transform: "translate(22.913 138.191) rotate(-45)",
    fill: "#9cd3fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.78,386.061,92.561,290.8l36.545-43.505,1.16-16.371L108.416,198.44l2.32-6.252-9.088-9.088-11.344,5.736L56.983,238.465,41.257,228.023l-4.705,11.086,4.9,34.353-63.315,112.6Z",
    transform: "translate(21.865 -68.31)",
    fill: "#f5b7aa"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.625,
    cy: 38.625,
    rx: 38.625,
    ry: 38.625,
    transform: "translate(266.817 72.239)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H90.234V12.891H0Z",
    transform: "translate(332.952 147.356) rotate(-135)",
    fill: "#f5b7aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.8,385.845l-32-95.045L304.26,247.295l-1.16-16.371,21.849-32.484-2.32-6.252,9.088-9.088,11.344,5.736,33.322,49.628,15.726-10.441,4.705,11.086-4.9,34.353L456.65,385.845Z",
    transform: "translate(-90.255 -68.31)",
    fill: "#f5b7aa"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.518)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(80.642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316,5h6.445V72.675H316Z",
    transform: "translate(-316 -5)",
    fill: "#c3bedd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.634 16.113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226,30h6.445V97.675H226Z",
    transform: "translate(-226 -30)",
    fill: "#c3bedd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.875,
    cy: 12.875,
    rx: 12.875,
    ry: 12.875,
    transform: "translate(58.04 54.664)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.875,
    cy: 12.875,
    rx: 12.875,
    ry: 12.875,
    transform: "translate(0 71.013)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.007,37.226,231,53.339V21.113L289.007,5Z",
    transform: "translate(-205.143 -5)",
    fill: "#c3bedd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.328 230.096)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241,362h6.445v54.785H241Z",
    transform: "translate(-241 -362)",
    fill: "#afabc7"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.875,
    cy: 12.875,
    rx: 12.875,
    ry: 12.875,
    transform: "translate(0 42.014)",
    fill: "#c3bedd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.336,366.834A18.467,18.467,0,0,0,252.9,362H246v19.336h6.9a18.589,18.589,0,0,1,12.439,4.834A18.467,18.467,0,0,0,277.775,391h6.9V371.668h-6.9A18.467,18.467,0,0,1,265.336,366.834Z",
    transform: "translate(-220.285 -362)",
    fill: "#c3bedd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.141 22.558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.467,48.314l8.314,4.576-8.314,4.576-4.576,8.314-4.576-8.314L91,52.891l8.314-4.576L103.891,40Z",
    transform: "translate(-91 -40)",
    fill: "#ffb234"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(292.702 9.668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.467,28.314l8.314,4.576-8.314,4.576-4.576,8.314-4.576-8.314L427,32.891l8.314-4.576L439.891,20Z",
    transform: "translate(-427 -20)",
    fill: "#ffd10a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(201.824 284.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.467,454.314l8.314,4.576-8.314,4.576-4.576,8.314-4.576-8.314L286,458.89l8.314-4.576L298.891,446Z",
    transform: "translate(-286 -446)",
    fill: "#ffd10a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.9,198.5l14.566,4.189,20.3,31.453,2.127,22.945,8.25-9.8,1.16-16.371L161.456,198.44l2.32-6.252-9.088-9.088-11.344,5.736Z",
    transform: "translate(-31.175 -68.31)",
    fill: "#f0917b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.506,198.5l-14.566,4.189-20.3,31.453-2.127,22.945-8.25-9.8-1.16-16.371,21.849-32.484-2.32-6.252,9.088-9.088,11.344,5.736Z",
    transform: "translate(-90.255 -68.31)",
    fill: "#f0917b"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSong);
export default __webpack_public_path__ + "static/media/song.2eb4ab7911814d672a778a8fdf39258f.svg";
export { ForwardRef as ReactComponent };